<template>
    <div>
    	<table class="room-table" cellspacing="0" v-if="!isLoading">
            <tbody>
                <tr style="text-align: left;vertical-align: top;">
                    <td class="roomType">{{rps.PriceTypeName +'&nbsp;&nbsp;'+"< " + rps.RatePlanName + " >"}}</td>
                    <td class="roomStatus">
                        <p>Status</p>
                        <p style="padding-top: 20px;">Inventory</p>
                    </td>
                    <td :class="(getDaysSize(today,day.PD)>=0&&day.S!='026001'&&day.S)?'change-room roomItem close':'change-room roomItem'" v-for="day in tableData" @click="toRoomStatusSingleEdit(day)">
                        <div v-if="day" class="roomContent">
                            <div v-if="day.A">
                                <p v-if="day.S=='026001'" class="roomOpen" @click.stop="setRoomStuts(day)" @mouseenter="day.mouse=true" @mouseleave="day.mouse=false">{{day.mouse?'Edit Status':'Open'}}</p>
                                <p v-else-if="day.S&&day.S!='026001'" class="roomClose" @click.stop="setRoomStuts(day)" @mouseenter="day.mouse=true" @mouseleave="day.mouse=false">{{day.mouse?'Edit Status':'Close'}}</p>
                                <p v-else class="roomWait">None</p>
                                <p style="padding-top: 15px;">
                                    <span style="color: #a48cfd;cursor: pointer;"> R </span>
                                    <label class="Pab" style="cursor: pointer;" v-if="day.O==false&&day.O!=null">(Cannot)</label>
                                    <span class="one Pab" style="cursor: pointer;" v-if="day.O">(Can)</span>
                                </p>
                            </div>
                            <div v-if="!day.A">
                                <p v-if="day.S=='026001'" class="roomOpen" @click.stop="setRoomStuts(day)" @mouseenter="day.mouse=true" @mouseleave="day.mouse=false">{{day.mouse?'Edit Status':'Open'}}</p>
                                <p v-else-if="day.S&&day.S!='026001'" class="roomClose" @click.stop="setRoomStuts(day)" @mouseenter="day.mouse=true" @mouseleave="day.mouse=false">{{day.mouse?'Edit Status':'Close'}}</p>
                                <p v-else class="roomWait">None</p>
                                <p style="padding-top: 15px;" v-if="!day.IsShared">
                                    <label class="size" style="cursor: pointer;" v-show="day.SC!=null">{{day.SC?day.SC:0}}</label>
                                    <label class="Pab" style="cursor: pointer;" v-if="day.O==false&&day.O!=null">(Cannot)</label>
                                    <span class="Pab one" style="cursor: pointer;" v-if="day.O">(Can)</span>
                                </p>
                                <p style="padding-top: 15px;" v-else>
                                    <label class="size" style="cursor: pointer;" v-show="day.SSC!=null">{{day.SSC?day.SSC:0}}</label>
                                    <label class="Pab" style="cursor: pointer;" v-if="day.O==false&&day.O!=null">(Cannot)</label>
                                    <span class="one Pab" style="cursor: pointer;" v-if="day.O">(Can)</span>
                                </p>
                            </div>
                        </div>
                        <div class="roomContent" v-else> </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <RoomStatusSingleEdit :cmData="cmSingleData" :rps="cmRps" :rooms='rooms' @upData="upData"></RoomStatusSingleEdit>
    </div>

</template>
<script>
import RoomStatusSingleEdit from './roomStatusEdit/RoomStatusSingle.vue'


export default {
    name:'dateStatusTable',
    components:{
        RoomStatusSingleEdit,
        
    },

    props:{
        rooms:{
    		type:Object,
            default:function(){
                return{}
            }
    	},
        rps:{
            type:Object,
            default:function(){
                return{}
            }
        },
        beginSlot:{
            type: String,
            default:''
        },
        
    },
    data(){
        return{
            cmRps:{},
            tableData:'',
            cmSingleData: {},
            today:this.getDate(0),
            begin:this.getDate(0),
            isLoading:true
        }
    },
    watch:{
        beginSlot(val){
            this.begin = val
            this.initDate()
        },
        rps(val){
            this.cmRps=val;
            this.initTable();
        }
    },
    methods:{
        initDate(){
            var arr=[]
            var date =''
            for(var i = 0;i<=6; i++){
                if(i==0){
                    date = this.begin
                }else{
                    date = this.getNextDay(this.begin,i)
                }
                arr.push(date)
            }
            this.$emit('select',this.begin,arr)
            this.initTable()
        },
        //获取月份的数据
        initTable(){
            var that=this;
            var cmRps=that.cmRps;
            var params={
              hotel: cmRps.HotelId,
              room: cmRps.RoomId,
              rp: cmRps.RatePlanId,
              rate: cmRps.RateId,
              date: that.begin.replace(/-/g,''),
              endDate:that.getNextDay(that.begin,10).replace(/-/g,'')
            }
            that.isLoading = true;
            that.getRequest({
                url: that.Api.getRp,
                params: params
            }).then(res => {
                that.isLoading = false;
                if (res && res.length>0) {
                    res.forEach(element => {
                        element.mouse = false
                    });
                    that.tableData = res                 
                } else {
                    that.tableData='';
                    that.error({ title: 'Tips', content: 'No data is queried' });
                }
            });
        },
        upData(){
            this.$emit('select',true,1)
        },
        setRoomStuts(day){
    		var that=this;
    		var rps=that.rps;
            var RPInfos=[{
				RPId:rps.RatePlanId,
				RateId:rps.RateId
			}]
			var params={
                HotelId: rps.HotelId,
                RoomId: rps.RoomId,
				RPInfos:RPInfos,
				Date:day.PD,
				IsOpen:day.S=='026001'?false:true,
				IsAsk:day.A,
				Count:day.SC||0,
				AllowOver:day.O,
				IsShared:day.IsShared,
				IsOnlyChangeRoomStatus:true
	        }
	        that.patchRequest({
	            url: that.Api.updateStateSingle,
	            params: params
	        }).then(res => {
	            if (res&&res.IsSuccess) {
	            //    this.initTable()
                   this.$emit('select',true,1)
	            } else {
	                that.error({ title: '提示', content: '提交失败，请重新提交' });
	            }
	        });
    	},

       
        //获取日期中的天
        getDateDay(date){
            var date=date;
            var day=date.split('/')[2];
            return day

        },
        //编辑单独一天的房态
        toRoomStatusSingleEdit(day){
            if(this.getDaysSize(this.today,day.PD)<0)return;//先判断当期日期是否可以编辑
            this.cmSingleData=JSON.parse(JSON.stringify(day));
            this.$nextTick(function () {
                this.$set(this.cmSingleData,'isShow',this.cmSingleData.isShow?false:true);
            });
        }
    },
    mounted(){
        this.cmRps=this.rps;
        this.initDate()
    }

}
</script>












// WEBPACK FOOTER //
// src/components/roomStatus/datePriceTable/table.vue